'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCallClass = createCallClass;

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _nestedtypes = require('nestedtypes');

var Nested = _interopRequireWildcard(_nestedtypes);

var _bluebird = require('bluebird');

var _serverErrors = require('../serverErrors');

var _CallState = require('./CallState');

var _CallEventType = require('./CallEventType');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var logger = _auroraJavascriptUtils.log.getLogger('rpc');

function createCallClass(methodDescriptor, requestClass, responseClass) {
    _auroraJavascriptUtils.assert.func(requestClass);
    _auroraJavascriptUtils.assert.func(responseClass);

    return Nested.Model.extend({
        defaults: {
            request: requestClass,
            response: responseClass,
            state: _CallState.CallState.factory.value(_CallState.CallState.CREATED)
        },

        initialize: function initialize(_ref) {
            var _this = this;

            var executor = _ref.executor;

            this.executor = _auroraJavascriptUtils.assert.func(executor);
            this.methodDescriptor = _auroraJavascriptUtils.assert.object(methodDescriptor);

            this.promise = null;
            this.stateMachine = methodDescriptor.methodType.createCallStateMachine();
            this.stateMachine.bind(function (event, oldState, newState) {
                _this.state = newState;
            });
        },
        toString: function toString() {
            var serviceDescriptor = this.methodDescriptor.serviceDescriptor;
            return methodDescriptor.methodType.name + ' / \'' + serviceDescriptor.serviceName + ':' + this.methodDescriptor.methodName + '\' / id: ' + this.id;
        },
        execute: function execute() {
            var _this2 = this;

            var self = this;
            if (typeof this.request.resetErrors === 'function') {
                this.request.resetErrors();
            }

            this.stateMachine.execute();

            this.promise = new _bluebird.Promise(function (resolve, reject) {
                if (!self.request.isValid()) {
                    throw new Error('request not valid \'' + JSON.stringify(_this2.request.toJSON()) + '\'');
                }

                var serviceCallPromise = _this2.executor(_this2.request);
                _auroraJavascriptUtils.assert.checkState(serviceCallPromise.then, 'service method must return promise!');

                return serviceCallPromise.then(function (superAgentResponse) {
                    var rawResponse = void 0;
                    if (superAgentResponse && superAgentResponse.body) {
                        rawResponse = superAgentResponse.body;
                    } else {
                        rawResponse = {};
                    }

                    self.response.set(rawResponse);

                    self.stateMachine.finishWithSuccess();
                    try {
                        self.trigger(_CallEventType.CallEventType.SUCCEED.name);
                    } catch (e) {
                        logger.error('One of event "SUCCEED" event handler failed');
                    }

                    return self.response;
                }).then(function (response) {
                    resolve(response);
                }, function (error) {
                    reject(error);
                });
            }).catch((0, _serverErrors.handleServerErrors)(self.request)).catch(function (error) {
                self.stateMachine.finishWithError();
                try {
                    self.trigger(_CallEventType.CallEventType.FAILED.name);
                } catch (e) {
                    logger.error('One of event "FAILED" event handler failed');
                }
                throw error;
            });

            return this.promise;
        },
        getCommonError: function getCommonError() {
            if (this.state === _CallState.CallState.FAILURE && typeof this.request.getCommonError === 'function') {
                return this.request.getCommonError();
            }
            return null;
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/callClassFactory.js
// module id = 474
// module chunks = 118